import { Team } from '@mews/enums';
import { loadScript } from '../../utils';
import { LoggerService } from '../logging';

declare global {
    interface Window {
        $fvIdentity?: FullviewOptions;
    }
}

export interface FullviewServiceOptions {
    apiKey: string;
    loggerService: LoggerService;
}

interface FullviewOptions {
    id: string;
    name: string;
    email: string;
    disableReplaysForUser: boolean;
    env: string;
    roles: string[];
    customField: Record<string, string | number | boolean>;
}

export interface FullviewService {
    initialize: () => Promise<void>;
    isInitialized: () => boolean;
    setUser: (options: FullviewOptions) => void;
}

export const createFullviewService = ({ apiKey, loggerService }: FullviewServiceOptions): FullviewService => {
    let initialized = false;
    return {
        initialize: async () => {
            if (apiKey === undefined) return;
            try {
                const src = `https://install.fullview.io`;
                await loadScript(src, { org: apiKey });
                initialized = true;
            } catch (error) {
                loggerService.log('script-load-error', 'Fullview failed to initialize.', {
                    error,
                    team: Team.Spacetime,
                });
            }
        },

        isInitialized: () => initialized,

        setUser: (options) => {
            if (!initialized) return;
            window.$fvIdentity = { ...options };
        },
    };
};
